import { Typography, TypographyProps } from '@mui/material'

type DisplayErrorProps = {
  message: string
  sx: object
} & TypographyProps
const DisplayError = ({ message, sx }: DisplayErrorProps) => {
  return (
    <Typography
      variant="caption"
      display="block"
      sx={{ color: '#ff0000', ...sx }}
    >
      {message}
    </Typography>
  )
}
export default DisplayError
